import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initPwaInstall } from './lib/pwaInstall';

// Before render, deliberately: Chrome fires `beforeinstallprompt` on its own
// schedule and will not re-fire it, so a listener attached once the Home panel
// mounts would miss it outright. See src/lib/pwaInstall.js.
initPwaInstall();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registers the minimal service worker (production builds only).
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
